module.exports = __webpack_public_path__ + "img/sketch-product.3e01d9a9.svg";